import styled, { css } from 'styled-components';

export const Container = styled.div<{ $hasSections?: boolean }>`
  padding-bottom: ${({ theme }) => theme.spacing(2.5)};

  ${({ $hasSections, theme }) =>
    !$hasSections &&
    css`
      padding-top: ${theme.spacing(2.5)};
      padding-left: ${theme.spacing(1.75)};
      padding-right: ${theme.spacing(1.75)};
    `};
`;
